import { observer } from 'mobx-react-lite'
import useStore from 'reusable/mobx-store-utils'
import AuthValidateLinkBelongsToUserStore from './AuthValidateLinkBelongsToUserStore'
import useInitialMount from 'reusable/hooks/useInitialMount'
import { useParams } from 'react-router-dom'
import { useRegionRouterStore } from 'features/main/RegionRouterStore'
import { notNull } from '@gap/utils/utils'
import { useAuthStore } from 'auth/AuthStore'
import { PlatformContainer } from 'reusable/containers/PlatformContainer'
import useQueryWithHash from 'reusable/hooks/useQueryWithHash'

/**
 * Validates a userId from an email link belongs to the current user
 */
export default observer(function AuthValidateLinkBelongsToUser() {
   const { userId } = useParams()
   const queryString = useQueryWithHash()
   const authStore = useAuthStore()
   const regionRouterStore = useRegionRouterStore()
   const redirectUrl = notNull(queryString.get('redirectUrl'))

   const authValidateLinkBelongsToUserStore = useStore((sp) => new AuthValidateLinkBelongsToUserStore(sp), { authStore, userId: notNull(userId), redirectUrl, regionRouterStore })

   useInitialMount(async () => {
      await authValidateLinkBelongsToUserStore.validateUserFromEmailLinkAndRedirect()
   })

   return (
      <PlatformContainer loadingMessage="Validating request" loading={true} contentCentered={true} />
   )
})
